(function (_, $, M) {
  'use strict';

  var course_id = $('body').data('course-id');

  _(M.courses).on('unenrolled', function () {
    window.location = '/home/';
  });

  M.renderer.ready(function () {
    if (M.user.is_authenticated) {
      var $container = $('.leaderboard-container');

      var leaderboard = M.newLeaderboard({
        fullBoardUrl: window.location.pathname + 'leaderboard/',
        endPoint: '/ajax/leaderboard/course/' + course_id + '/',
        howMany: $container.hasClass('wide') ? 50 : 10,
        large: $container.hasClass('wide'),
        showTabs: true,
      });

      if ($container.length > 0) m.mount($container[0], leaderboard);
    }

    $('[data-placement]').tooltip({ container: 'body' });

    $(document).on('click', '[data-role="course-restart"]', function () {
      M.modal.yes_no(
        _t('Restart?'),
        _t(
          'This will __s1__wipe your learning history for this course__s2__. __br__You will start from the beginning again. __br__Are you sure?',
          {
            s1: '<strong>',
            s2: '</strong>',
            br: '<br /><br />',
          },
        ),
        function () {
          M.modal.spinner_open(
            _t('Restarting'),
            _t('Wiping your learning history...'),
          );
          course_restart(course_id);
        },
      );
      return false;
    });

    function course_restart(course_id) {
      $.ajax({
        url: '/ajax/course/restart/',
        type: 'POST',
        data: {
          course_id: course_id,
        },
        success: function (response) {
          if (response.success) {
            window.location.reload();
          }
        },
      });
    }

    if ($('.course-description .text').width() > 300) {
      $('span.text-expand')
        .show()
        .on('click', function () {
          $('.course-description span').removeClass('ellipsis');
          $(this).remove();
        });
    }
  });
})(_, jQuery, MEMRISE);
